export default __webpack_public_path__ + "static/media/confirmation-outline-icon.03670bc5.svg";